import { Client } from "@microsoft/microsoft-graph-client";
/**
 * Creates a Microsoft Graph client authenticated with the provided access token.
 *
 * The token is passed as a static bearer — it must be refreshed externally
 * (via ssoHelper.acquireGraphToken) before the token expires.
 * For this add-in's use case (single fetch on compose), this is sufficient.
 */
export function createGraphClient(accessToken) {
    return Client.init({
        authProvider: (done) => {
            done(null, accessToken);
        },
    });
}
